import React from 'react';
import { useHistory, Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import FooterLayout from 'components/layouts/FooterLayout';
import HeaderMenuCustom from 'components/headerMenu/HeaderMenuCustom';

import { useScreen } from 'hooks/useDimensions';

const FooterRoutesStatic = ({
  component: Component,
  HeaderMenu,
  headerMenuStyles,
  withDownloadsSection,
  withSubScenery,
  pageStatus,
  backTo,
  ...rest
}) => {
  const { isXlScreen } = useScreen();
  const history = useHistory();
  const isWebView = useSelector(({ app }) => app?.isWebView);

  return (
    <>
      {isXlScreen ? (
        <HeaderMenu />
      ) : !isWebView && (
        <div className={headerMenuStyles}>
          {backTo ? (
            <HeaderMenuCustom onBackTo={() => {
              if (backTo === 'previous') {
                if (history?.length > 2) {
                  history.goBack();
                } else {
                  history.push('/');
                }
              } else {
                history.push(backTo);
              }
            }}
            />
          ) : (
            <HeaderMenuCustom />
          )}
        </div>
      )}
      {pageStatus === 404
        ? (<Redirect to="/not-found" />) : (
          <Route
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...rest}
            render={(props) => (
              <FooterLayout
                withDownloadsSection={withDownloadsSection}
                withSubScenery={withSubScenery}
              >
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <Component {...props} />
              </FooterLayout>
            )}
            status={pageStatus}
          />
        )}
    </>
  );
};

FooterRoutesStatic.defaultProps = {
  withDownloadsSection: false,
  withSubScenery: false,
  pageStatus: null,
  backTo: 'previous',
};

FooterRoutesStatic.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.object]).isRequired,
  HeaderMenu: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.object]).isRequired,
  headerMenuStyles: PropTypes.string.isRequired,
  withDownloadsSection: PropTypes.bool,
  withSubScenery: PropTypes.bool,
  pageStatus: PropTypes.number,
  backTo: PropTypes.string,
};

export default FooterRoutesStatic;
